import React, { Component } from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Masonry from "react-masonry-component";
import ProductCard from "./ProductCard";

const styles = theme => ({
  showcase: {},
  item: {
    margin: 10,
    [`@media (min-width: ${theme.mediaQueryTresholds.M}px)`]: {
      width: `calc(${100 / 3}% - 20px)`,
      float: "left"
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.XL}px)`]: {
      width: `calc(${100 / 4}% - 20px)`
    }
  }
});

class Masonary extends Component {
  render() {
    const { products, classes, className } = this.props;
    return (
      <Masonry className={className}>
        {products.map(product => (
          <div key={product.id} className={classes.item}>
            <ProductCard product={product} />
          </div>
        ))}
      </Masonry>
    );
  }
}

Masonary.propTypes = {
  classes: PropTypes.object.isRequired,
  products: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired
};

export default injectSheet(styles)(Masonary);



// WEBPACK FOOTER //
// ./src/components/Product/Masonary.jsx